import React, { useEffect, useState } from "react";
import PageHero from "../components/PageHero";
import SEO from "../components/SEO";
import { api } from "../api";
import { FileText, ImageIcon, Download } from "lucide-react";

const iconFor = (type) => {
  if (type === "pdf") return FileText;
  return ImageIcon;
};

const Documents = () => {
  const [items, setItems] = useState([]);

  useEffect(() => {
    api.documents().then(setItems).catch(() => setItems([]));
  }, []);

  return (
    <main className="bg-white">
      <SEO title="Dokümanlar" description="Koptur Grup A.Ş. kurumsal dokümanları, katalog ve raporlar." path="/dokumanlar" />
      <PageHero
        kicker="Belgeler"
        title="Dokümanlar"
        subtitle="Kurumsal dokümanlarımızı, katalogları ve raporları buradan indirebilirsiniz."
      />
      <section className="pb-24">
        <div className="max-w-[1200px] mx-auto px-4 md:px-6">
          {items.length === 0 ? (
            <div className="text-neutral-500 text-center py-16">Henüz yayımlanmış doküman yok.</div>
          ) : (
            <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
              {items.map((d) => {
                const Icon = iconFor(d.file_type);
                return (
                  <a
                    key={d.id}
                    href={d.file_url}
                    target="_blank"
                    rel="noreferrer"
                    download={d.file_name || d.title}
                    className="group flex items-start gap-4 p-5 rounded-2xl border border-neutral-100 hover:border-[#C9A24B] hover:shadow-[0_20px_40px_rgba(0,0,0,0.06)] transition-all bg-white"
                  >
                    <div className="w-12 h-12 rounded-xl bg-[#4E0D1C]/10 text-[#4E0D1C] flex items-center justify-center shrink-0">
                      <Icon className="w-6 h-6" />
                    </div>
                    <div className="flex-1 min-w-0">
                      <div className="font-bold text-[#1a1a1a] group-hover:text-[#4E0D1C] transition-colors">{d.title}</div>
                      {d.description && <p className="text-sm text-neutral-600 mt-1 line-clamp-2">{d.description}</p>}
                      <div className="mt-3 inline-flex items-center gap-1.5 text-xs font-semibold text-[#C9A24B]">
                        <Download className="w-3.5 h-3.5" /> İndir
                      </div>
                    </div>
                  </a>
                );
              })}
            </div>
          )}
        </div>
      </section>
    </main>
  );
};

export default Documents;
